/* eslint-disable no-unused-vars */
import Vue from "vue";
import { getDatabase, ref, query, get, set, push, child, serverTimestamp, orderByChild, equalTo } from "firebase/database";

import { FETCH_TRAININGS, CREATE_TRAINING, GET_TRAINING, CREATE_LESSON } from "../actions";
import { SET_KEY } from "../mutations";

const database = getDatabase();

const state = {
  errors: null,
};

const getters = {
  hasErrors(state) {
    return state.errors;
  },
};

const mutations = {
  [SET_KEY](state, { key, value }) {
    Vue.set(state, key, value);
  },
};

const actions = {
  async [FETCH_TRAININGS]() {
    let result;

    await get(child(ref(database), `trainings`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          console.log(snapshot.val());
          result = snapshot.val();
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
      });

    return result;
  },
  [CREATE_TRAINING](_, { config }) {
    const createdAt = serverTimestamp();
    config.createdAt = createdAt;

    const id = push(child(ref(database), "trainings")).key;
    set(ref(database, `trainings/${id}`), { config });
  },
  async [GET_TRAINING](_, { trainingId, hasAccess }) {
    let config = {};
    let lessons = {};

    await get(child(ref(database), `trainings/${trainingId}/config`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          console.log(snapshot.val());
          config = snapshot.val();
        } else {
          console.log("No data available");
        }
      })
      .catch((error) => {
        console.error(error);
      });

    /* TODO: This is not secured at all ^-^ */
    if (hasAccess)
      await get(query(ref(database, `trainingsLessons`), orderByChild("trainingId"), equalTo(trainingId)))
        .then((snapshot) => {
          if (snapshot.exists()) {
            console.log(snapshot.val());
            lessons = snapshot.val();
          } else {
            console.log("No data available");
          }
        })
        .catch((error) => {
          console.error(error);
        });

    return { config, lessons };
  },

  [CREATE_LESSON](_, { config, ...payload }) {
    const createdAt = serverTimestamp();
    config.createdAt = createdAt;

    const id = push(child(ref(database), "trainingsLessons")).key;
    set(ref(database, `trainingsLessons/${id}`), { config, ...payload });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
